import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ratingTexts = ["Needs Improvement", "Nice", "Good", "Great", "Excellent"];

export default function ProductRating({ rating = 0 }) {
  return (
    <span className="bb-pro-rating">
      {[...Array(5)].map((_, idx) => {
        const isFilled = idx < rating;
        const tooltipText = ratingTexts[idx] || "Rating";

        return (
          <OverlayTrigger
            key={idx}
            placement="top"
            overlay={<Tooltip>{tooltipText}</Tooltip>}
          >
            <i
              className={`bi ${isFilled ? "bi-star-fill" : "bi-star"}`}
              style={{
                color: isFilled ? "#ffc107" : "#e4e5e9",
                cursor: "pointer",
                fontSize: "1.2rem",
                marginRight: 2,
              }}
            />
          </OverlayTrigger>
        );
      })}
    </span>
  );
}
